module.exports = __webpack_public_path__ + "static/full_stack-b8fb5cf3fdc766921258e4da362b3bd1.svg";